/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendIdDto } from '../../models/backend-id-dto';
import { BackendIdRequestDto } from '../../models/backend-id-request-dto';

export interface FinancingSourcesUnblockCreditsVariantsCreate$FormData$Params {
  body: BackendIdRequestDto;
}

export function financingSourcesUnblockCreditsVariantsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesUnblockCreditsVariantsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendIdDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesUnblockCreditsVariantsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendIdDto>;
    }),
  );
}

financingSourcesUnblockCreditsVariantsCreate$FormData.PATH = '/api/financing_sources/unblock-credits-variants/';
